export const ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT_ROUTE_NAME = Symbol('admin.settings.table-columns-edit');
export const TRANSLATION_GROUP_GENERAL_SETTINGS_TABLE_COLUMNS_EDIT = Symbol('general-settings.table-columns-edit');

export const HISTORY_CHANGES_OF_TABLE_COLUMNS_QUERY = 'history-changes-table-columns-edit';
export const HISTORY_CHANGES_OF_TABLE_COLUMNS_API_URL = 'admin/table_for_displays/versions_list';

export const TABLE_ENABLED_COLUMNS_LIST_QUERY = 'table-enabled-columns-list';
export const TABLE_DISABLED_COLUMNS_LIST_QUERY = 'table-disabled-columns-list';
export const TABLE_COLUMNS_LIST_API_URL = 'admin/table_columns_for_displays/:listType';

export const SAVE_TABLE_COLUMNS_MUTATION = 'save-table-columns';
export const SAVE_TABLE_COLUMNS_API_URL = 'admin/table_columns_for_displays/update_list';
